import React from 'react';
import {UrlFixer} from "../../utils/utils";
import {ListItemThumb} from "../../utils/common-styles";
import styled from 'styled-components';
import {DateDisplay} from "../Extra/DateDisplay";
import GalleryWidget from "../Extra/GalleryWidget";
import {MarkdownDisplay} from "../Extra/MarkdownDisplay";
import {DownloadsWidget} from "../Extra/DownloadsWidget";
import {ShareButtons} from "../Extra/ShareButtons";
import {Container, Row, Col} from "react-bootstrap";
import {Helmet} from "react-helmet";

const ItemTitle = styled.div`
    margin-top: 25px;
    color: var(--forest-green);
    & h2 {
        font-family: "Roboto Slab", serif;
        font-weight: bold;
    }
`;

const ItemMainImageCaption = styled.div`
    background-color: #fff;
    font-style: italic;
    font-size: 0.8rem;
    padding-left: 5px;
    border-bottom-left-radius: 5px;
    border-bottom-right-radius: 5px;
    border-top: solid 2px #0a2b1d;
`;

const PostMeta = styled(Container)`
`;

const StyledIntro = styled.section`
    margin-top: 2rem;
`;


export const ArticleItemDetail = ({post}) => {

    const articleItem = post;

    return (
        <>
            <Helmet>
                <title>{articleItem.title}</title>
                <meta property="og:type" content="article" />
                <meta property="og:title" content={articleItem.title} />
                <meta property="og:description" content={articleItem.intro?.substring(0, 155)} />
                <meta property="og:url" content={window.location.href} />
                <meta name="description" content={articleItem.intro?.substring(0, 155)} />
                <meta property="og:image" content={UrlFixer('/og-large-profile.jpg')} />
            </Helmet>
            {articleItem.image_details && <ListItemThumb>
                <img src={UrlFixer(articleItem.image_details.variations.detail_hero)} alt={articleItem.caption}/>
                <ItemMainImageCaption>{articleItem.image_details.caption}</ItemMainImageCaption>
            </ListItemThumb>}


            <ItemTitle><h2>{articleItem.title}</h2></ItemTitle>
            <PostMeta className="post-meta">
                <Row>
                    <Col xs={12} md={3}>
                        <i className="fas fa-calendar-alt"> </i> <DateDisplay datetime={articleItem.published_at}/>
                    </Col>
                    <Col xs={12} md={6}>
                        {articleItem.tags && articleItem.tags.length > 0 && <><i className="fas fa-tags"></i> <ul className="tag-list">{articleItem.tags.map((tag) => {
                            return <li key={tag.id}>{tag.name}</li>
                        })}</ul></>}
                    </Col>
                    <Col xs={12} md={3}>
                        <ShareButtons title={articleItem.title} shareUrl={window.location.href} />
                    </Col>
                </Row>
            </PostMeta>

            <article>
                <section>
                    <StyledIntro>
                        <MarkdownDisplay text={articleItem.intro} plugins={[]} />
                    </StyledIntro>
                </section>
                <main>
                    <MarkdownDisplay text={articleItem.body} plugins={[]} />
                </main>
            </article>
            <GalleryWidget images={articleItem.gallery_details} />
            {articleItem.documents && articleItem.documents.length > 0 && <DownloadsWidget downloads={articleItem.documents} />}
        </>
    )
}
